import React from "react";
import { push } from "connected-react-router";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";

import IconButton from "@material-ui/core/IconButton";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

import { useDispatch, useSelector } from "react-redux";
import { getUserRole } from "../../reducks/users/selectors";
import NoImage from "../../assets/img/src/no_image.png";
//import {getUserRole} from "../../reducks/users/selectors";
import { useState } from "react";
import { deleteProduct } from "../../reducks/products/operations";
import { PERMISSIONS } from "../../constants/permissions";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("sm")]: {
      margin: 8,
      width: "calc(50% - 16px)",
    },
    [theme.breakpoints.up("md")]: {
      margin: 16,
      width: "calc(33.3333% - 32px)",
    },
  },
  content: {
    display: "flex",
    padding: "16 8",
    textAlign: "left",
    "&:last-child": {
      paddingBottom: 16,
    },
  },
  icon: {
    marginRight: 0,
    marginLeft: "auto",
  },
  media: {
    height: 0,
    paddingTop: "100%",
  },
  price: {
    color: theme.palette.warning.main,
    fontSize: 16,
  },
  productNameDisplay: {
    boxOrient: "vertical",
    display: "-webkit-box",
    fontSize: 14,
    lineHeight: "18px",
    overflow: "hidden",
    [theme.breakpoints.down("sm")]: {
      height: 36,
      lineClamp: 2,
    },
    [theme.breakpoints.up("md")]: {
      height: 18,
      lineClamp: 1,
    },
  },
  productNameHidden: {
    boxOrient: "vertical",
    display: "-webkit-box",
    fontSize: 14,
    lineHeight: "18px",
    overflow: "hidden",
    color: theme.palette.primary.main,
    [theme.breakpoints.down("sm")]: {
      height: 36,
      lineClamp: 2,
    },
    [theme.breakpoints.up("md")]: {
      height: 18,
      lineClamp: 1,
    },
  },
  productIdin: {
    boxOrient: "vertical",
    display: "-webkit-box",
    fontSize: 14,
    lineHeight: "18px",
    overflow: "hidden",
    color: theme.palette.error.main,
    [theme.breakpoints.down("sm")]: {
      height: 36,
      lineClamp: 2,
    },
    [theme.breakpoints.up("md")]: {
      height: 18,
      lineClamp: 1,
    },
  },
  iconButton: {
    width: 48, // または適切なサイズ
    height: 48, // または適切なサイズ
  },
}));
const ProductCard = (props) => {
  const price = props.price.toLocaleString();
  const classes = useStyles();
  const dispatch = useDispatch();
  const userRole = useSelector(getUserRole);
  const isAdministrator =
    userRole === PERMISSIONS.ADMINISTRATOR ||
    userRole === PERMISSIONS.HUMAN_RESOURCE_USER;
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const images = props.images.length > 0 ? props.images : [{ path: NoImage }];
  return (
    <Card className={classes.root}>
      <CardMedia
        className={classes.media}
        image={images[0].path}
        title=""
        onClick={() => dispatch(push("/product/" + props.id))}
      />
      <CardContent className={classes.content}>
        <div onClick={() => dispatch(push("/product/" + props.id))}>
          {props.display === "表示" && (
            <>
              <Typography
                className={classes.productIdin}
                color="textPrimary"
                component="p"
              >
                {props.idin}
              </Typography>
              <Typography
                className={classes.productNameDisplay}
                color="textPrimary"
                component="p"
              >
                {props.name}
              </Typography>
            </>
          )}
          {props.display === "非表示" && (
            <>
              <Typography
                className={classes.productIdin}
                color="textPrimary"
                component="p"
              >
                {props.idin}
              </Typography>
              <Typography
                className={classes.productNameHidden}
                color="textPrimary"
                component="p"
              >
                {props.name}
              </Typography>
            </>
          )}
          <Typography component="p" className={classes.price}>
            {price}
          </Typography>
        </div>
        {isAdministrator && (
          <>
            <IconButton className={classes.iconButton} onClick={handleClick}>
              <MoreVertIcon />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              <MenuItem
                onClick={() => {
                  dispatch(push("/product/edit/" + props.id));
                  handleClose();
                }}
              >
                編集する
              </MenuItem>
              <MenuItem
                onClick={() => {
                  dispatch(deleteProduct(props.id));
                  handleClose();
                }}
              >
                削除する
              </MenuItem>
            </Menu>
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default ProductCard;
